import { ClientListStatus } from 'types/api/clientList';

export const STATUS = {
  [ClientListStatus.NEW]: {
    tooltip: 'Готов к построению',
    indicator: { bgColor: 'accent.70', borderColor: '#1e88e53d' },
  },
  [ClientListStatus.ERROR]: {
    tooltip: 'Ошибка при построении',
    indicator: { bgColor: 'state.error', borderColor: '#f443363d' },
  },
  [ClientListStatus.MARKED]: {
    tooltip: 'Размечен',
    indicator: { bgColor: 'accent.70', borderColor: '#1e88e53d' },
  },
  [ClientListStatus.MATCHING]: {
    tooltip: 'В процессе построения',
    indicator: { bgColor: 'accent.70', borderColor: '#1e88e53d' },
  },
  [ClientListStatus.MATCHED]: {
    tooltip: 'Построен',
    indicator: { bgColor: 'grey.40', borderColor: 'transparent' },
  },
};
